import { EventIcon } from "@faire/deprecated-retailer-visitor-shared/components/Events/shared/EventIcon";
import { FaireMarketTheme } from "@faire/web/slate/Theme/EventsTheme";
import * as React from "react";

interface IProps {
  size?: string;
  className?: string;
}

export const FaireMarketIcon = (props: IProps) => {
  return (
    <EventIcon
      size={props.size}
      customIcon={FaireMarketTheme.eventIcon?.Component}
      className={props.className}
    />
  );
};
